import React from 'react';
import './Footer.css';
import wrapLogo from '../assets/w.png';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <hr className="footer__divider" />
      <div className="footer__container">
        <div className="footer__left">
          <img src={wrapLogo} alt="Wrap" className="footer__logo" />
          <p className="footer__description">Inspiring genuine relationships through real photos, real moments, real you.</p>
          <p className="footer__copy">© 2025 Wrap App, Inc. All rights reserved.</p>
        </div>
        
        <div className="footer__right">
          <div className="footer__col">
            <h3 className="footer__heading">Resources</h3>
            <a href="/safe-dating" className="footer__link">Safe Dating</a>
            <a href="/trust-safety" className="footer__link">Trust & Safety</a>
            <a href="/faq" className="footer__link">FAQ</a>
          </div>
          
          <div className="footer__col">
            <h3 className="footer__heading">Legal</h3>
            <a href="/security" className="footer__link">Security</a>
            <a href="/terms" className="footer__link">Terms</a>
            <a href="/privacy" className="footer__link">Privacy</a>
            <a href="/accessibility" className="footer__link">Accessibility</a>
          </div>
          
          <div className="footer__col">
            <h3 className="footer__heading">Connect</h3>
            <a href="https://tiktok.com" className="footer__link" target="_blank" rel="noreferrer">TikTok</a>
            <a href="https://instagram.com" className="footer__link" target="_blank" rel="noreferrer">Instagram</a>
            <a href="https://linkedin.com" className="footer__link" target="_blank" rel="noreferrer">LinkedIn</a>
            <a href="mailto:hello@wrapapp.com" className="footer__link">Email</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


